'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const Loader = styled.div`
  border: 1px solid ${colors.secondary.lightGray2};
  border-radius: 5px;
`;
